import React, { ChangeEventHandler } from 'react'
import { colors } from '@lmc/common/constants'
import { FormInput as OldFormInput } from '../../../LEGACY/elemental'
import 'cleave.js/dist/addons/cleave-phone.gb'
import Cleave from 'cleave.js/react'
import AnimateHeight from 'react-animate-height'
import styles from '../../../LEGACY/FormInput/styles'
import { css, StyleSheet } from 'aphrodite/no-important'
import theme from '../../../LEGACY/theme'

type FormInputProps = {
  error?: string
  format?: boolean
  inputStyle?: object
  onChange: ChangeEventHandler<HTMLInputElement>
  options?: object
  placeholder?: string
  className?: string
  style?: object
  type?: string
  value?: string | number
  disabled?: boolean
  readOnly?: boolean
}

export default function FormInput({
  error,
  format,
  inputStyle = {},
  onChange,
  options,
  placeholder,
  className,
  style,
  type,
  value,
  disabled,
  ...inputProps
}: FormInputProps) {
  // @ts-ignore
  const classes = StyleSheet.create(styles)
  const Input = format ? Cleave : OldFormInput
  let fullClassName = ''
  if (className) fullClassName += className
  if (format) fullClassName += ` ${css(classes.FormInput)}`

  const formatProps = format ? { options } : null
  return (
    <div style={style}>
      <Input
        className={fullClassName}
        onChange={!disabled ? (e) => onChange(e) : undefined}
        placeholder={placeholder || ''}
        style={{
          ...localStyles.input,
          // @ts-ignore
          borderColor: error ? colors.red : null,
          background: disabled ? '#fafafa' : '',
          pointerEvents: disabled ? 'none' : 'auto',
          ...inputStyle,
          opacity: disabled ? 0.39 : 1,
        }}
        type={format ? undefined : type}
        value={value || ''}
        {...inputProps}
        {...formatProps}
      />
      <AnimateHeight animateOpacity duration={200} height={error ? 'auto' : 0}>
        <div style={localStyles.error}>{error}</div>
      </AnimateHeight>
    </div>
  )
}

const localStyles = {
  error: {
    color: colors.red,
    fontSize: 11,
    paddingTop: 5,
  },
  input: {
    height: theme.input.height,
    width: '100%',
  },
}
